import { UpdateHealthGoalRequest, UpdateHealthGoalResponse } from 'features/profile/types';
import { WellframeApi } from 'store/api';

export const healthGoalService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    updateHealthGoal: builder.mutation<UpdateHealthGoalResponse, UpdateHealthGoalRequest>({
      query: ({ memberUuid, health_goal, conditions }) => ({
        url: `/mobileapi/v1/members/${memberUuid}/health-goal`,
        method: 'PUT',
        body: {
          member_uuid: memberUuid,
          health_goal,
          conditions: conditions ?? [],
        },
      }),
    }),
  }),
});

export const { useUpdateHealthGoalMutation } = healthGoalService;
